import { Component, HostListener, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'messageBox',
  templateUrl: './messageBox.component.html',
  styleUrls: ['./messageBox.component.scss'],
})
export class MessageBoxComponent {

  constructor(public dialogRef: MatDialogRef<MessageBoxComponent>, @Inject(MAT_DIALOG_DATA) public data: MessageBoxParameters) {
    this.dialogRef.disableClose = true;
  }

  @HostListener('window:keyup.esc') onKeyUp() {
    this.dialogRef.close();
  }

  public SetResultAndClose(result: string) {
    this.data.result = result;
    this.dialogRef.close(result);
  }
}

// tslint:disable-next-line:max-classes-per-file
export class MessageBoxParameters {
  public message: string;
  public title: string;
  public result: string;
  public showOkBtn: boolean;
  public showYesBtn: boolean;
  public showNoBtn: boolean;
  public showConfirmBtn: boolean;
  public showCloseBtn: boolean;
  public showCancelBtn: boolean;
  public defaultNo = false;
  public defaultCancel = true;
  public warning = false;

  constructor(message?: string, title?: string, type?: MessageBoxType, defaultNoOrCancel?: boolean, warning?: boolean ) {
    this.message = message || 'No message specified.  Please click a button to close this message';
    this.title = title || 'Message Box';
    this.result = '';
    this.warning = warning;

    this.showOkBtn = true;
    this.showYesBtn = false;
    this.showNoBtn = false;
    this.showConfirmBtn = false;
    this.showCloseBtn = false;
    this.showCancelBtn = false;

    if (type){
      switch (type){
        case MessageBoxType.YesNo:
          this.showOkBtn = false;
          this.showYesBtn = true;
          this.showNoBtn = true;
          this.defaultNo = defaultNoOrCancel || this.defaultNo;
          break;

        case MessageBoxType.YesNoCancel:
          this.showOkBtn = false;
          this.showYesBtn = true;
          this.showNoBtn = true;
          this.showCancelBtn = true;
          this.defaultNo = defaultNoOrCancel || this.defaultNo;
          break;

        case MessageBoxType.Confirm:
          this.showOkBtn = false;
          this.showConfirmBtn = true;
          this.showCancelBtn = true;
          this.defaultCancel = defaultNoOrCancel || this.defaultCancel;
          break;

        case MessageBoxType.None:
          this.showOkBtn = false;
          break;

        default:
          this.showOkBtn = true;
      }
    }
    else
    {
      // if no type specified then add OK button so user can close the dialog box
      this.showOkBtn = true;
    }
  }
}

export enum MessageBoxType{
  Ok,
  YesNo,
  Confirm,
  None,
  YesNoCancel,
}
